<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="nonindent" id="ded">To my loving parents and special wife Carole, and my insightful children and awesome grandchildren.<br/><br/>
We understood and believed in each other, and that made all the difference.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062046253_epub_ded_r1.vue?273dd2a8